import { DeliveredDirections, TaxData } from '../model/http/profile.model';
import { BooleanCons } from './const';

export const TaxDataInitialization = new TaxData();
TaxDataInitialization.isNeedTaxData = BooleanCons.true;
export const DirectionDataInitialization = new DeliveredDirections();
DirectionDataInitialization.saveShippingCost = BooleanCons.true;
export const TaxDataBackInitialization = new TaxData();
TaxDataBackInitialization.isNeedTaxData = BooleanCons.true;
export const DirectionDataBackInitialization = new DeliveredDirections();
DirectionDataBackInitialization.saveShippingCost = BooleanCons.true;
